import { Platform, User } from './types.js';

export class BrowserPlatform implements Platform {
  readonly type = 'browser';
  readonly isTelegram = false;
  readonly rawInitData = undefined;

  async initialize() {
    console.log('Browser platform initialized');
  }

  get user(): User | undefined {
    // Mock user for local development
    return {
      id: 0,
      firstName: 'Stalker',
      username: 'stalker_dev',
    };
  }

  readonly haptic = {
    impact: () => {},
    notification: () => {},
    selectionChanged: () => {}
  };

  expand() {
    console.log('Expand is not supported in browser');
  }

  async requestFullscreen() {
    if (document.documentElement.requestFullscreen) {
      await document.documentElement.requestFullscreen();
    }
  }

  applyTheme() {
    console.log('Using default browser theme');
  }
}
